import { FormatSegment } from '@app/app/_components/DatePicker/FormatSegment';

export function parseFormatToSegments(format: string): FormatSegment[] {
    const segments: FormatSegment[] = [];
    let i = 0;
    let digitOffset = 0;

    while (i < format.length) {
        if (format.startsWith('yyyy', i)) {
            segments.push({ kind: 'year', length: 4, digitOffset });
            digitOffset += 4;
            i += 4;
        } else if (format.startsWith('MM', i)) {
            segments.push({ kind: 'month', length: 2, digitOffset });
            digitOffset += 2;
            i += 2;
        } else if (format.startsWith('dd', i)) {
            segments.push({ kind: 'day', length: 2, digitOffset });
            digitOffset += 2;
            i += 2;
        } else {
            segments.push({ kind: 'separator', char: format[i] });
            i += 1;
        }
    }

    return segments;
}
